module.exports = __webpack_public_path__ + "static/media/a-2-a.440780d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-2-a.jpg
// module id = 1092
// module chunks = 33